import { has, clone, get } from 'lodash';
import moment from '~/_moment';
import { SessionProfileActionTypes } from '~/actions/session';

const initialState = {};

export default (state = initialState, action) => {
  const { type, ...param } = action;

  // `action.type`
  switch (type) {
    case SessionProfileActionTypes.LOAD:
    case SessionProfileActionTypes.LOAD_STATUS:
      if (has(param, 'status')) {
        const { status } = param;
        let newState = state;

        if (has(status, 'pressure')) {
          newState = {
            ...newState,
            pressure: {
              start: moment(status.pressure.start),
              end: moment(status.pressure.end),
            },
          };
        }

        if (has(status, 'seismic')) {
          const statusInfo = get(status, 'seismic.station_info', []);
          newState = {
            ...newState,
            seismic: statusInfo.map(({ station, sync_at: syncAt, save_at: { date: saveAt } }) => ({
              station,
              syncAt: moment(syncAt),
              saveAt: moment(saveAt),
            })),
          };
        }

        return clone({ ...state, ...newState });
      }

      return state;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/reducers/damStatus.js